// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2MZok","filesListContainer":"PosDisputesFiles_filesListContainer__2k_m2","filesButton":"PosDisputesFiles_filesButton__2tOVT"};